import { TemplateAction } from '../../action-types';
import { VideoTemplateStateContent } from '../../types';
import {
  setTemplateUCSCompatibility,
  setTemplateUCSCompatibilityLoading,
} from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'TEMPLATE_UCS_COMPATIBILITY': {
      return setTemplateUCSCompatibility(state, action.payload);
    }

    case 'TEMPLATE_UCS_COMPATIBILITY_LOADING': {
      return setTemplateUCSCompatibilityLoading(state, action.payload);
    }

    default:
      return state;
  }
}
